import styled from 'styled-components';

export const StyledShopAssetModal = styled.div`
  width: ${({ theme }) => theme.assetModalWidth};
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .asset-modal-preview-content {
    width: 100%;
    height: ${({ theme }) => theme.assetModalPreviewHeight};
    position: relative;
    background: ${({ theme }) => theme.brightBlue};
  }

  .asset-modal-preview-content-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .asset-modal-preview-image-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

export const ShopAssetDescriptionAndTraits = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
`;

export const ShopAssetInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0rem;
  border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  padding: 1.25rem 1.5rem;
  padding-top: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);

  .asset-modal-info-traits {
    width: 50%;
  }
`;

export const ShopAssetDesciption = styled.div`
  width: 50%;
  padding-top: 0.75rem;
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-weight: 400;
  font-size: 1.25rem;
`;

export const SkinSelector = styled.div`
  width: 36%;
`;
